import { useMemo } from 'react';
import { useWidthData } from '../components/utils/contexts/WindowWidthContext';
import type { ResponsivePropsParams } from './responsiveProps.types';

export type { ResponsiveProps, ResponsivePropsParams } from './responsiveProps.types';

export const useResponsiveProps = <T extends object>({
  props,
  smProps,
  mdProps,
  lgProps,
  xlProps,
}: ResponsivePropsParams<T>): T => {
  const { moreSm, moreMd, moreLg, moreXlg } = useWidthData();

  return useMemo(
    () => ({
      ...props,
      ...(moreSm ? smProps : {}),
      ...(moreMd ? mdProps : {}),
      ...(moreLg ? lgProps : {}),
      ...(moreXlg ? xlProps : {}),
    }),
    [props, smProps, mdProps, lgProps, xlProps, moreSm, moreMd, moreLg, moreXlg]
  );
};
